// utils/whatsappHelper/orderLookup/toTypedNumber.ts — Map config bot → WhatsAppNumber.
// Boilerplate flag fitur dipisah dari orderLookup.ts agar file utama tetap ringkas (SOP ≤100).
import type { WhatsAppNumber } from '../types.js';

export function toTypedNumber(c: any): WhatsAppNumber {
  return {
    id: c.id,
    name: c.botName || '',
    phoneNumber: (c.waNumber || '').replace(/^\+/, ''),
    apiKey: c.waba_token || '',
    isActive: c.isActive ?? true,
    device: c.waba_phone_id || '',
    assignedBrandIds: c.brandId ? [c.brandId] : [],
    assignedCsIds: c.assignedCsIds || [],
    sendOrderConfirmation: true,
    sendShippingUpdate: true,
    sendDeliveryConfirmation: true,
    sendCancellationMessage: true,
    sendPaymentReminder: true,
    sendWelcomeMessage: true,
    sendFollowUp1: false,
    sendFollowUp2: false,
    sendFollowUp3: false,
    sendFollowUp4: false,
    sendFollowUp5: false,
    sendAbandonedCart: true,
    sendStockAlert: false,
    sendBirthdayGreeting: false,
    sendReviewRequest: false,
    sendReturnNotification: true,
    sendPromoMessage: false,
  };
}
